import { Button } from "@mui/material";
import React from "react";
import microsoftLogo from 'src/assets/images/MicrosoftIcon.png';
import googleLogo from 'src/assets/images/GoogleIcon.png';

export default class SSOLogin extends React.Component {
    render() {
        return (
            <>
                <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    disabled={true}
                    startIcon={<img src={googleLogo} alt="google_logo" width={'auto'} height={'25px'} />}
                    style={{ color: 'gray', backgroundColor: '#f0f0f0ff', margin: '8px 0' }}
                >
                    Sign in with Google (coming soon)
                </Button>

                <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    disabled={true}
                    startIcon={<img src={microsoftLogo} alt="microsoft_logo" width={'auto'} height={'15px'} />}
                    style={{ color: 'gray', backgroundColor: '#f0f0f0ff', margin: '8px 0' }}
                >
                    Sign in with Microsoft (coming soon)
                </Button>
            </>
        );
    }
}
